import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './DentistHero1.css';

const DentistHero1 = () => {
  const navigate = useNavigate();

  const handleAppointmentClick = (e) => {
    e.preventDefault();
    console.log('Appointment button clicked!');
    navigate('/appointment');
  };

  const handleServicesClick = (e) => {
    e.preventDefault();
    console.log('Services button clicked!');
    navigate('/services');
  };

  return (
    <section className="dentist-hero">
      <div className="hero-container">
        <div className="hero-content">
          <div className="hero-text">
            <div className="hero-badge">
              <svg className="badge-icon" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2L13.09 8.26L22 9L13.09 9.74L12 16L10.91 9.74L2 9L10.91 8.26L12 2Z"/>
              </svg>
              <span>Expert Dental Care by Dr. Muhammad Junaid</span>
            </div>
            
            <h1 className="hero-title">
              Your Perfect Smile,
              <span className="title-highlight"> Our Commitment</span>
            </h1>
            
            <p className="hero-description">
              Welcome to Prime Care Dental, where Dr. Muhammad Junaid 
              provides comprehensive dental care including advanced general dentistry, orthodontics, 
              dental implants, root canal therapy, and complete oral health solutions for the whole family.
            </p>
            
            <div className="hero-stats">
              <div className="stat-item">
                <div className="stat-number">15+</div>
                <div className="stat-label">Years Experience</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">5000+</div>
                <div className="stat-label">Happy Patients</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">98%</div>
                <div className="stat-label">Success Rate</div>
              </div>
            </div>
            
            <div className="hero-buttons">
              <button onClick={handleAppointmentClick} className="btn-primary">
                <svg className="btn-icon" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19 3H18V1H16V3H8V1H6V3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3M19 19H5V8H19V19M7 10H12V15H7"/>
                </svg>
                Book Appointment
              </button>
              
              <button onClick={handleServicesClick} className="btn-secondary">
                <svg className="btn-icon" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2C6.48 2 2 6.48 2 12S6.48 22 12 22 22 17.52 22 12 17.52 2 12 2M10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z"/>
                </svg>
                Our Services
              </button>
            </div>
            
            <div className="hero-features">
              <div className="feature-item">
                <svg className="feature-icon" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2L13.09 8.26L22 9L13.09 9.74L12 16L10.91 9.74L2 9L10.91 8.26L12 2Z"/>
                </svg>
                <span>Advanced General Dentistry</span>
              </div>
              <div className="feature-item">
                <svg className="feature-icon" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 1L9 9L1 9L7 14L5 22L12 18L19 22L17 14L23 9L15 9L12 1Z"/>
                </svg>
                <span>Orthodontics & Dental Implants</span>
              </div>
              <div className="feature-item">
                <svg className="feature-icon" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2C6.48 2 2 6.48 2 12S6.48 22 12 22 22 17.52 22 12 17.52 2 12 2M10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z"/>
                </svg>
                <span>Complete Family Dental Care</span>
              </div>
            </div>
          </div>
          
          <div className="hero-image">
            <div className="image-container">
              <img 
                src="https://images.unsplash.com/photo-1629909613654-28e377c37b09?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80" 
                alt="Modern dental clinic interior with professional equipment and comfortable patient chair"
                className="hero-clinic-image"
              />
              
              {/* Floating Elements */}
              <div className="floating-card card-1">
                <div className="card-icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2L13.09 8.26L22 9L13.09 9.74L12 16L10.91 9.74L2 9L10.91 8.26L12 2Z"/>
                  </svg>
                </div>
                <div className="card-content">
                  <div className="card-title">5 Star Rating</div>
                  <div className="card-subtitle">Google Reviews</div>
                </div>
              </div>
              
              <div className="floating-card card-2">
                <div className="card-icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M9 11H7V9H9V11M13 11H11V9H13V11M17 11H15V9H17V11M19 3H18V1H16V3H8V1H6V3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3M19 19H5V8H19V19Z"/>
                  </svg>
                </div>
                <div className="card-content">
                  <div className="card-title">Same Day</div>
                  <div className="card-subtitle">Appointments</div>
                </div>
              </div>
              
              <div className="floating-card card-3">
                <div className="card-icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2C6.48 2 2 6.48 2 12S6.48 22 12 22 22 17.52 22 12 17.52 2 12 2M10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z"/>
                  </svg>
                </div>
                <div className="card-content">
                  <div className="card-title">Insurance</div>
                  <div className="card-subtitle">Accepted</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        {/* Background Elements */}
        <div className="hero-bg-elements">
          <div className="bg-circle circle-1"></div>
          <div className="bg-circle circle-2"></div>
          <div className="bg-circle circle-3"></div>
        </div>
      </div>
    </section>
  );
};

export default DentistHero1;
